<template>
  <div class="input-wrapper">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.input-wrapper {
  flex: 1;
  min-width: 200px;
}
</style>
